"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["size", "UNSAFE_size"];
var SIZES = {
  small: 16,
  medium: 20,
  large: 24
};

var withSize = function withSize(Icon) {
  var SizedIcon = function SizedIcon(_ref) {
    var size = _ref.size,
        UNSAFE_size = _ref.UNSAFE_size,
        props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var actualSize = (0, _isNumber2["default"])(UNSAFE_size) ? UNSAFE_size : SIZES[size];
    return /*#__PURE__*/_react["default"].createElement(Icon, (0, _extends2["default"])({
      focusable: "false",
      height: actualSize,
      width: actualSize
    }, props));
  };

  SizedIcon.propTypes = {
    size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(Object.keys(SIZES))]),
    UNSAFE_size: _propTypes["default"].number
  };
  SizedIcon.defaultProps = {
    size: 'medium',
    UNSAFE_size: null
  };
  SizedIcon.isIcon = true;
  return SizedIcon;
};

var _default = withSize;
exports["default"] = _default;